import { Checkbox, Grid } from "@material-ui/core"
import { DataGrid, GridColumnProps, SelectFilterComponent, SelectFloatingFilterComponent } from "@roc/ui";
import { formatCurrency, noOpComparator } from "@roc/ui/utils";
import { useRocInternalPortalStore } from "apps/roc-internal-portal/src/app/hooks";
import { observer } from "mobx-react";

const columns: GridColumnProps[] = [
  {
    field: 'drawId',
    headerName: '',
    maxWidth: 75,
    cellRenderer: 'selectedCellRenderer',
    sortable: false,
  },
  {
    field: 'drawNumber',
    headerName: 'Draw Number',
    maxWidth: 125,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'propertyAddress',
    headerName: 'Property Address',
    minWidth: 275,
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'withheldWireFees',
    headerName: 'Withheld Wire Fees',
    minWidth: 50,
    cellRenderer: 'amountRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'withheldInspectionFees',
    headerName: 'Withheld Inspection Fees',
    minWidth: 50,
    cellRenderer: 'amountRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
  {
    field: 'amount',
    headerName: 'Amount',
    minWidth: 50,
    cellRenderer: 'amountRenderer',
    comparator: noOpComparator,
    filter: 'agTextColumnFilter',
    floatingFilter: true,
    floatingFilterComponentParams: {
      suppressFilterButton: true,
    },
  },
];

export const DrawsToConsolidateGrid = observer(() => {
  const { sendWireInternalStore } = useRocInternalPortalStore();
  const gridStore = sendWireInternalStore.consolidateDrawsGridStore;

  const frameworkComponents = {
    selectFilter: SelectFilterComponent,
    selectFloatingFilter: SelectFloatingFilterComponent,
    amountRenderer: ({ value }) => value !== undefined && value !== null ? formatCurrency(value) : '',
    selectedCellRenderer: params => <CheckboxColumn store={sendWireInternalStore} node={params.node} />,
  };

  const CheckboxColumn = observer(({ store, node }) => {
    const id = node.data?.drawId;
    const isSelected = store.selectedDrawItems.some(
      p => id === p.drawId
    )
    const isDisabled = node.data?.disabled;
    return (
      <Checkbox
        checked={isSelected}
        disabled={isDisabled || sendWireInternalStore.readOnlyMode}
        onChange={(e, checked) => {
          store.selectedDrawRow(node.data);
        }}
        color="primary"
      />
    );
  })

  return (
    <Grid container spacing={2} style={{ paddingBottom: '5px' }}>
      <Grid item xs={12} style={{ padding: '10px' }}>
        <DataGrid
          columns={columns}
          rows={gridStore.gridData.data.rows}
          domLayout="autoHeight"
          suppressRowClickSelection={true}
          frameworkComponents={frameworkComponents}
        />
      </Grid>
    </Grid>
  )
});

export default DrawsToConsolidateGrid;
